<div class="container">
    <div>{{'footer' | translate}}</div>
  <ul class="navigation">
    <li> Contact: Tel 032 344 39 69/ Fax 032 344 39 66</li>
    <li>Serviceline Mo-Fr, 08:00h – 17:30h</li>
  </ul>
</div>

